import React, { FC } from 'react';
import classNames from 'classnames';

interface IconProps {
  className?: string;
  width?: number;
  height?: number;
}

export const IconCopy: FC<React.PropsWithChildren<IconProps>> = ({ className, width = 32, height = 32 }) => (
  <svg className={classNames([className])} width={width} height={height} viewBox={`0 0 20 20`} fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7 2H15C15.5523 2 16 2.44772 16 3V11C16 11.5523 15.5523 12 15 12H7C6.44772 12 6 11.5523 6 11V3C6 2.44772 6.44772 2 7 2ZM4 3C4 1.34315 5.34315
       0 7 0H15C16.6569 0 18 1.34315 18 3V11C18 12.6569 16.6569 14 15 14H14V15C14 16.6569 12.6569 18 11 18H3C1.34315 18 0 16.6569 0 15V7C0 5.34315
        1.34315 4 3 4H4V3ZM4 6H3C2.44772 6 2 6.44772 2 7V15C2 15.5523 2.44772 16 3 16H11C11.5523 16 12 15.5523 12 15V14H7C5.34315 14 4 12.6569 4 11V6Z"
      fill="currentColor"
    />
  </svg>
);
